import { router } from "@inertiajs/react"
import ChannelMenu, { type ScopeNode } from "@/components/ChannelMenu"
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/ToggleGroup"
import type { RowKind } from "@/pages/Plan/components/ActualsTable"
import type { PeriodKey } from "@/pages/Plan/components/ActualsToolbar"
import PeriodMenu, { type PeriodPreset, type PeriodValue } from "@/pages/Revenue/components/PeriodMenu"
import Inline from "./Inline"

const PRESETS: PeriodPreset<PeriodKey>[] = [
  { key: "today", label: "Today" },
  { key: "this_month", label: "This month" },
  { key: "plan_period", label: "Plan period" },
]

interface Props {
  scopeTree: ScopeNode[]
  scope: { id: string; name: string }
  hrefForScope: (slug: string) => string
  categoryTree: ScopeNode[]
  category: { id: string; name: string } | null
  hrefForCategory: (slug: string) => string
  period: PeriodValue<PeriodKey>
  planBegin: string
  planEnd: string
  onPeriodChange: (patch: { preset: PeriodKey | "custom"; from?: string; to?: string }) => void
  rowKind: RowKind
  hrefForRowKind: (kind: RowKind) => string
}

// The table's controls, inline in its section bar: they change the table only.
export default function TableControls(props: Props) {
  return (
    <div className="flex flex-wrap items-center gap-5">
      <Inline label="Scope">
        <ChannelMenu
          scopeTree={props.scopeTree}
          currentNodeId={props.scope.id}
          currentNodeName={props.scope.name}
          hrefForChannel={props.hrefForScope}
          requireLeaf={false}
        />
      </Inline>
      <Inline label="Category">
        <ChannelMenu
          scopeTree={props.categoryTree}
          currentNodeId={props.category?.id ?? "all"}
          currentNodeName={props.category?.name ?? "All categories"}
          hrefForChannel={props.hrefForCategory}
          requireLeaf={false}
          label="Category"
        />
      </Inline>
      <Inline label="Period">
        <PeriodMenu
          value={props.period}
          presets={PRESETS}
          minDate={props.planBegin}
          maxDate={props.planEnd}
          onChange={props.onPeriodChange}
        />
      </Inline>
      <Inline label="Break down by">
        <ToggleGroup
          type="single"
          value={props.rowKind}
          onValueChange={(v) => v && router.get(props.hrefForRowKind(v as RowKind), {}, { preserveScroll: true })}
        >
          <ToggleGroupItem value="products" size="sm">Products</ToggleGroupItem>
          <ToggleGroupItem value="categories" size="sm">Category</ToggleGroupItem>
          <ToggleGroupItem value="channels" size="sm">Channel</ToggleGroupItem>
        </ToggleGroup>
      </Inline>
    </div>
  )
}
